var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-33"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.33,
    y: 389.91,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.97,
    y: 398.37,
    width: 44.03,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.46,
    y: 399.19,
    width: 44.78,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.69,
    y: 389.66,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.79,
    y: 389.66,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 393.88,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.15,284.93H86.26V113.82c0-13.63,120.89-13.63,120.89,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.37,284.93H83.49V113.82c0-13.63,120.89-13.63,120.88,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.49,276.34V117.2a2.58,2.58,0,0,1,1.71-2.44c6.71-2.42,25-5.16,52.73-5.16s46,2.74,52.73,5.16a2.58,2.58,0,0,1,1.71,2.44V276.34a2.58,2.58,0,0,1-2.58,2.59H92.07A2.58,2.58,0,0,1,89.49,276.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,110.75,96.19,278.93h27.53l19-169.33C132,109.63,122.74,110.08,115,110.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.64,109.66l-19,169.27h15.21l18.92-168.7C161.18,110,156.12,109.75,150.64,109.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 191.45,
    width: 174.14,
    height: 5.28,
    transform: "translate(358.66 29.51) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 191.45,
    width: 174.14,
    height: 5.28,
    transform: "translate(316.14 72.03) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1,
    y: 193.61,
    width: 174.14,
    height: 0.95,
    transform: "translate(319.25 68.92) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.62,
    y: 193.61,
    width: 174.14,
    height: 0.95,
    transform: "translate(361.77 26.4) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.31,
    y: 145.38,
    width: 114,
    height: 5.28,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.98,
    y: 283.32,
    width: 123.33,
    height: 5.83,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.31,
    y: 283.32,
    width: 5.84,
    height: 5.83,
    transform: "translate(408.46 572.47) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,284.93H301.13V113.82c0-13.63,120.89-13.63,120.89,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.24,284.93H298.36V113.82c0-13.63,120.88-13.63,120.88,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.36,276.34V117.2a2.58,2.58,0,0,1,1.71-2.44c6.71-2.42,25-5.16,52.73-5.16s46,2.74,52.73,5.16a2.58,2.58,0,0,1,1.71,2.44V276.34a2.58,2.58,0,0,1-2.58,2.59H306.94A2.58,2.58,0,0,1,304.36,276.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.91,110.75,311.06,278.93h27.53l19-169.33C346.87,109.63,337.61,110.08,329.91,110.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.51,109.66l-19,169.27h15.21l18.92-168.7C376.05,110,371,109.75,365.51,109.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.37,
    y: 191.45,
    width: 174.14,
    height: 5.28,
    transform: "translate(573.52 -185.36) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.85,
    y: 191.45,
    width: 174.14,
    height: 5.28,
    transform: "translate(531.01 -142.84) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.97,
    y: 193.61,
    width: 174.14,
    height: 0.95,
    transform: "translate(534.12 -145.95) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.49,
    y: 193.61,
    width: 174.14,
    height: 0.95,
    transform: "translate(576.64 -188.47) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.18,
    y: 145.38,
    width: 114,
    height: 5.28,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.85,
    y: 283.32,
    width: 123.33,
    height: 5.83,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.18,
    y: 283.32,
    width: 5.84,
    height: 5.83,
    transform: "translate(838.2 572.47) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.11,
    y: 77.22,
    width: 30.15,
    height: 8.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.19,
    y: 85.74,
    width: 30.15,
    height: 8.52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.63,
    y: 196.38,
    width: 30.15,
    height: 8.52,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 312.86,
    width: 30.15,
    height: 8.52,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.49,
    y: 315.53,
    width: 30.15,
    height: 8.52,
    transform: "translate(209.12 639.58) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.02,
    y: 68.7,
    width: 30.15,
    height: 8.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.24,
    y: 307.01,
    width: 30.15,
    height: 8.52,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.95,
    y: 302.75,
    width: 30.15,
    height: 8.52,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.16,
    y: 315.53,
    width: 30.15,
    height: 8.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.85,
    y: 85.74,
    width: 30.15,
    height: 8.52,
    transform: "translate(615.85 180.01) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.75,90.11a13.47,13.47,0,1,0,0-26.94h-1.62V90.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.13,
    cy: 76.64,
    r: 13.47,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.39,73.38c-2.34,2.93-5.49,4.31-7,3.09s-.87-4.6,1.47-7.53,5.49-4.31,7-3.09S424.73,70.44,422.39,73.38Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.13,
    cy: 76.64,
    r: 1.89,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26,100H421.77a4,4,0,0,1-4-4h0a4,4,0,0,1,4-4h10.49a4,4,0,0,1,4,4h0A4,4,0,0,1,432.26,100Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.37,100H419.88a4,4,0,0,1-4-4h0a4,4,0,0,1,4-4h10.49a4,4,0,0,1,4,4h0A4,4,0,0,1,430.37,100Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.36,95.31,435,94.25a6.14,6.14,0,0,0,4-7.71l1.06-.33A7.26,7.26,0,0,1,435.36,95.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.09,88h0a1.08,1.08,0,0,1-1.34-.7l-.38-1.2a1.08,1.08,0,0,1,.7-1.34h0a1.06,1.06,0,0,1,1.34.7l.38,1.2A1.07,1.07,0,0,1,440.09,88Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-33",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hats--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.67,103.88a.53.53,0,0,1-.48-.3c-.86-1.79.18-3.2,1.27-4.7,1.57-2.15,3.52-4.82,1.46-10-3.64-9.28-.73-14.68-.6-14.9a.53.53,0,0,1,.92.52c0,.05-2.78,5.21.67,14,2.27,5.77,0,8.82-1.6,11-1.15,1.58-1.72,2.46-1.17,3.62a.53.53,0,0,1-.25.71A.59.59,0,0,1,104.67,103.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.81,75.68a1.49,1.49,0,1,1,1.48-1.48A1.49,1.49,0,0,1,106.81,75.68Zm0-1.91a.43.43,0,1,0,0,.85.43.43,0,0,0,0-.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.61 94.56 124.11 95.39 74.56 125.66 74.06 124.83 94.14 102.01 123.61 94.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.11 95.39 104.03 118.21 74.56 125.66 94.64 102.84 124.11 95.39",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43,113.05a125.11,125.11,0,0,0-28.86,17.63,1.14,1.14,0,0,1-1.7-.22l-5.3-8.68a1.13,1.13,0,0,1,.29-1.45,125.11,125.11,0,0,1,29.43-18,1.12,1.12,0,0,1,1.42.4l5.3,8.68A1.14,1.14,0,0,1,120.43,113.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43,113.05a125.11,125.11,0,0,0-28.86,17.63,1.14,1.14,0,0,1-1.7-.22l-5.3-8.68a1.13,1.13,0,0,1,.29-1.45,125.11,125.11,0,0,1,29.43-18,1.12,1.12,0,0,1,1.42.4l5.3,8.68A1.14,1.14,0,0,1,120.43,113.05Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.39,200.34a.79.79,0,0,1-.6-.28c-1.86-2.2-1-4.58-.1-7.09,1.35-3.76,2.87-8-3.29-13.88-12.18-11.58-4.63-23-4.55-23.06a.8.8,0,0,1,1.1-.21.81.81,0,0,1,.21,1.11c-.29.41-6.85,10.38,4.33,21,6.92,6.57,5.05,11.77,3.69,15.57-.92,2.57-1.39,4.09-.18,5.52a.79.79,0,0,1-.1,1.12A.75.75,0,0,1,398.39,200.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.54,158.69a2.22,2.22,0,1,1,2.15-2.78h0a2.23,2.23,0,0,1-1.59,2.71A2.2,2.2,0,0,1,390.54,158.69Zm0-2.86-.16,0a.59.59,0,0,0-.39.3.61.61,0,0,0-.07.48.64.64,0,0,0,.78.46.65.65,0,0,0,.46-.78h0a.65.65,0,0,0-.3-.39A.62.62,0,0,0,390.54,155.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.45 240.08 426.44 240.86 379.77 180.04 380.78 179.26 413.55 202.43 427.45 240.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.44 240.86 393.67 217.69 379.77 180.04 412.54 203.21 426.44 240.86",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74,238.49a165.32,165.32,0,0,0-27.18-35.41,1.51,1.51,0,0,1,.05-2.27l10.65-8.17a1.49,1.49,0,0,1,1.94.17,165.23,165.23,0,0,1,27.72,36.12,1.49,1.49,0,0,1-.33,1.93L404.94,239A1.5,1.5,0,0,1,402.74,238.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74,238.49a165.32,165.32,0,0,0-27.18-35.41,1.51,1.51,0,0,1,.05-2.27l10.65-8.17a1.49,1.49,0,0,1,1.94.17,165.23,165.23,0,0,1,27.72,36.12,1.49,1.49,0,0,1-.33,1.93L404.94,239A1.5,1.5,0,0,1,402.74,238.49Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.16,219.31a76.45,76.45,0,0,0,20,5.28.7.7,0,0,1,.62.84l-1.59,6a.69.69,0,0,1-.76.49A76.78,76.78,0,0,1,119,226.53a.68.68,0,0,1-.42-.8l1.59-6A.69.69,0,0,1,121.16,219.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.26 216.96 114.42 216.39 148.68 225.46 148.53 226.03 129.99 226.81 114.26 216.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.42 216.39 132.95 215.61 148.68 225.46 130.14 226.24 114.42 216.39",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "114.42 216.39 132.95 215.61 148.68 225.46 130.14 226.24 114.42 216.39",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,221.2a.23.23,0,0,1-.14,0,.28.28,0,0,1-.1-.38c.34-.59.08-1.08-.47-2a5.36,5.36,0,0,1-.37-5.92c2.21-4.51,1-7.34,1-7.37a.28.28,0,0,1,.14-.37.27.27,0,0,1,.37.14c.06.12,1.37,3.1-.95,7.85a4.78,4.78,0,0,0,.34,5.37c.52.84,1,1.63.47,2.54A.27.27,0,0,1,132.5,221.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.61,206.2h-.06a.82.82,0,0,1-.54-.28.78.78,0,0,1-.18-.57.77.77,0,0,1,.27-.54.81.81,0,0,1,.58-.18.74.74,0,0,1,.53.27.79.79,0,0,1-.6,1.3Zm0-1a.19.19,0,0,0-.14.05.19.19,0,0,0-.08.15.23.23,0,0,0,.2.25.23.23,0,0,0,.25-.21.23.23,0,0,0-.21-.24Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.77,121.16c-7.23-2-11.28,9.38-13.22,18.9A13.58,13.58,0,0,1,225.14,151s25.47,16.57,44.45,7.41c15.28-7.38,10.4-24.83,3.52-32.86S253.18,114.25,248.77,121.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.86 407.32 254.22 408.17 245.23 387.61 253.87 386.77 262.86 407.32",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.63 381.98 310.66 387.5 297.99 370.99 304.97 365.47 317.63 381.98",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.92,384.34l5.59-8.34a.72.72,0,0,1,.91-.26l7.24,3.48a1.44,1.44,0,0,1,.52,2.08c-2,2.87-3.11,4.16-5.57,7.83-1.51,2.26-4.53,7.47-6.62,10.59s-5.28,1.21-4.69-.27c2.65-6.66,2.58-10.5,2.24-13.56A2.34,2.34,0,0,1,307.92,384.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.07,405.5h10.61a.89.89,0,0,1,.84.65l2.3,8.39a1.32,1.32,0,0,1-1.29,1.68c-3.74,0-5.51,0-10.17,0H241.1c-3.88,0-4.69-3.91-3.08-4.27,7.19-1.59,11.33-3.79,13.55-5.88A2.17,2.17,0,0,1,253.07,405.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.24 387.62 249.87 398.21 258.88 398.21 253.88 386.77 245.24 387.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.97 365.47 298 371 304.53 379.51 311.5 373.98 304.97 365.47",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,223.33S220.24,276.27,225.19,315C228.5,340.93,246,395.14,246,395.14l15.43-.39s-12.5-55.07-13.79-76.57c-2.21-36.77,16-94.91,16-94.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.79 395.94 262.86 395.46 261.75 389.6 242.43 389.6 243.79 395.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.9,223.42s2.35,57.83,15.24,90.37c10.4,26.29,40.81,65,40.81,65l9.29-8.09s-19.3-40.94-27.2-58.48c-19.38-43,1.92-72.82-9.75-89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.99 379.91 311.92 370.09 308.68 364.8 295.62 375.67 299.99 379.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.82,388.9a1.29,1.29,0,0,1-.75-.35.68.68,0,0,1-.25-.65c.19-1.11,3.14-2.38,3.47-2.52a.17.17,0,0,1,.19,0,.17.17,0,0,1,0,.19c-.42,1.11-1.27,3-2.36,3.27A1.06,1.06,0,0,1,305.82,388.9Zm2.22-3c-1,.47-2.76,1.41-2.87,2.09a.34.34,0,0,0,.14.32.79.79,0,0,0,.77.25C306.7,388.38,307.42,387.4,308,385.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.62,386.11a2,2,0,0,1-1.25-.42.71.71,0,0,1-.08-.88,1.08,1.08,0,0,1,.71-.57c1.24-.32,3.37,1.09,3.46,1.15a.21.21,0,0,1,.08.16.2.2,0,0,1-.1.15A6.35,6.35,0,0,1,305.62,386.11Zm-.05-1.56a1.5,1.5,0,0,0-.48,0,.72.72,0,0,0-.49.39c-.13.26-.06.39,0,.47.49.49,2.37.39,3.36.07A6.54,6.54,0,0,0,305.57,384.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.37,407.22a3.51,3.51,0,0,1-2.05-.49,1.26,1.26,0,0,1-.52-1,.56.56,0,0,1,.25-.55c1-.66,4.81,1.12,5.25,1.33a.17.17,0,0,1,.1.18.18.18,0,0,1-.14.15A14.11,14.11,0,0,1,248.37,407.22Zm-1.7-1.83a.86.86,0,0,0-.43.09.24.24,0,0,0-.09.24.92.92,0,0,0,.38.73c.87.65,3,.38,4.13.16A13.46,13.46,0,0,0,246.67,405.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.22,406.85h-.06c-1.16-.47-3.59-2.42-3.46-3.39,0-.2.17-.46.7-.53,2.07-.24,3,3.56,3,3.72a.18.18,0,0,1-.06.17A.16.16,0,0,1,251.22,406.85Zm-2.63-3.59h-.15c-.36.05-.38.18-.39.23-.08.62,1.65,2.2,2.91,2.86C250.7,405.47,249.92,403.26,248.59,403.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.83 137.91 179.76 131.17 199.8 122.85 219.22 113.16 222.29 119.9 202.25 128.22 182.83 137.91",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.83 137.91 179.76 131.17 199.8 122.85 219.22 113.16 222.29 119.9 202.25 128.22 182.83 137.91",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.53,
    y: 119.96,
    width: 2.5,
    height: 8.02,
    rx: 1.13,
    transform: "translate(-27.3 65.32) rotate(-17.01)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.1,
    y: 123.42,
    width: 2.5,
    height: 8.02,
    rx: 1.13,
    transform: "translate(-37.34 137.81) rotate(-35.38)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,134.55l2.12-7.7-9.19,1.72s.12,5.42,4.48,8.19Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.51 119.63 195.93 122.18 196.43 128.57 205.62 126.85 202.51 119.63",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.81,152c.23-8.2,3.58-19.61,3.58-19.61l4.65-.58a90.54,90.54,0,0,0-.47,17.52Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,187.25c-.58.16-.92.24-1.37.35l-1.25.28-2.46.53c-1.63.34-3.26.67-4.92.93a87,87,0,0,1-10.21,1.18,41.66,41.66,0,0,1-11.47-.83,23.44,23.44,0,0,1-6.61-2.57c-.56-.32-1.13-.73-1.68-1.12l-.21-.15-.28-.23-.57-.48c-.33-.32-.67-.65-1-1a17.54,17.54,0,0,1-2.48-3.63,29.19,29.19,0,0,1-2.27-6c-.49-1.85-.81-3.6-1.09-5.31-.58-3.41-.84-6.69-1.11-9.92s-.39-6.42-.49-9.6l-.15-4.77-.07-2.4c0-.83-.05-1.57-.05-2.5l20,1.78c-.13.57-.27,1.33-.39,2l-.33,2.12c-.21,1.42-.36,2.85-.52,4.28-.27,2.85-.46,5.71-.49,8.51a67.1,67.1,0,0,0,.33,8.13,36,36,0,0,0,.6,3.58,13,13,0,0,0,.78,2.47c.11.21.18.27,0,.11s-.1-.11-.17-.16a.69.69,0,0,0-.13-.11l-.07-.06h0c.08,0,.11.09.21.14a6.09,6.09,0,0,0,1.81.65,22.19,22.19,0,0,0,6.56.14,47.81,47.81,0,0,0,7.69-1.5c1.29-.37,2.59-.76,3.87-1.22.64-.23,1.27-.47,1.9-.72l.91-.38c.27-.12.64-.28.78-.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.63,345.71c1.41,5.48,2.91,11,4.39,16.27,4.36-1.21,10.56-3,17.44-5.25-1.17-6.08-2.3-12.29-3.26-18.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.43,324l-19.57,7.46c3,5.28,6.29,10.62,9.6,15.71,6.4-2.92,12.18-6.08,16.36-9.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M231.44,174c.58,13.73-17.25,70.16-8.94,185.39,8.34,1.88,68.43-23.51,75.5-30.75-.61-13.81-25.95-103.35-19.69-154,.4-3.21-1.43-6.25-4.64-6.72-2.71-.4-6.09-.8-9.5-1a116,116,0,0,0-16.49,0c-4.12.39-8.64,1.16-11.7,1.73A5.36,5.36,0,0,0,231.44,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.49,148.45c-1,5.31-2,15,1.68,18.56,0,0-5.29,8.27-14.31,12.35-7.18-6.08-2.18-12.31-2.18-12.31,5.91-1.42,5.75-5.81,4.71-9.93Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.48,180.59l1.12-6.4,12.17-9.85,4.17,2.4S256,180.94,249.48,180.59Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.48,180.59l1.12-6.4L249,166l-3.87.71S243,180.94,249.48,180.59Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6,174.19s5.23,5.16,5.49,9.83c3.53-3.44,12-14.46,12.17-17.64-1.85-1.54-5.6-2.48-5.6-2.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6,174.19s-5.08,4-5.35,8.71c-3.53-3.44-1.87-13.18-1.43-15.87,1.85-1.54,5.54-2,5.54-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.37,152l-6,5.12a17,17,0,0,1,.52,2.93c2.26-.33,5.66-2.37,5.89-4.73A9.3,9.3,0,0,0,258.37,152Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.91,140.48c-3,8.37-4,12-9.58,15.11-8.34,4.73-18-.72-17.58-9.81.35-8.17,5.12-20.48,14.43-21.49A12.11,12.11,0,0,1,267.91,140.48Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.41,130.74c-5.26,1.85-4.8,12.35.42,16S276.29,126.57,264.41,130.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,127c5.3,4.65,12.91,6.45,15.58,5.1,1.94,1.51,8.4,4.57,4.55-2.72s-10.67-8.23-15.11-8.17S244.49,123,249,127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.94,148.36a7,7,0,0,1-4.29,3c-2.28.49-3.12-1.71-2.24-3.9.79-2,2.93-4.59,5.1-4.09S269.18,146.44,267.94,148.36Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,139.17c-.2.69-.73,1.15-1.18,1s-.66-.79-.46-1.49.72-1.15,1.18-1S254.51,138.48,254.31,139.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.47,136.93c-.2.7-.73,1.16-1.18,1s-.66-.8-.46-1.49.72-1.15,1.18-1S246.67,136.24,246.47,136.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.2,135.54l-1.53-1S245.15,136.13,246.2,135.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2,138.72a19.36,19.36,0,0,1-3.73,3.72,3.12,3.12,0,0,0,2.34,1.17Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.78,147.24a6.53,6.53,0,0,1-1.3-.24.17.17,0,0,1-.12-.22.17.17,0,0,1,.21-.12,5.77,5.77,0,0,0,5.13-.87.18.18,0,0,1,.25,0,.18.18,0,0,1,0,.25A5.86,5.86,0,0,1,249.78,147.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.59,135.1a.34.34,0,0,1-.28-.2,3.4,3.4,0,0,0-2.46-1.93.37.37,0,0,1-.31-.4.36.36,0,0,1,.39-.3,4.11,4.11,0,0,1,3,2.32.36.36,0,0,1-.16.47A.41.41,0,0,1,258.59,135.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.73,132.55a.34.34,0,0,1-.29-.2.36.36,0,0,1,.17-.47,4.16,4.16,0,0,1,3.8.1.37.37,0,0,1,.11.49.36.36,0,0,1-.49.11,3.38,3.38,0,0,0-3.12-.06A.29.29,0,0,1,243.73,132.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,172.44l1-7.92,7.81,5.12s-2.19,5-7.28,5.83Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.66 159.05 323.76 163.93 320.83 169.64 313.02 164.52 318.66 159.05",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,191.49c2.94-7.65,4.24-19.47,4.24-19.47l-4.07-2.32A90.88,90.88,0,0,1,306.26,186Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,171.09c.53,1.12,1.21,2.46,1.87,3.68s1.37,2.47,2.08,3.69c1.43,2.44,2.94,4.82,4.52,7.1a76.81,76.81,0,0,0,4.93,6.44c.85,1,1.7,1.9,2.55,2.74a22.27,22.27,0,0,0,2.42,2.06,5,5,0,0,0,.51.34l.22.15c.07,0,0,0,0,0l-.08,0a3.42,3.42,0,0,0-1.25-.29,3.57,3.57,0,0,0-1.22.16c-.23.08-.23.1-.13,0a8,8,0,0,0,1.38-1.52,27.39,27.39,0,0,0,1.75-2.77,49,49,0,0,0,3-7.05c.46-1.26.83-2.56,1.21-3.86l.5-2c.08-.33.15-.66.21-1s.15-.68.16-.86L321.63,184c-.2.53-.35.86-.53,1.26l-.5,1.14-1,2.25c-.66,1.49-1.38,3-2.09,4.45a92.57,92.57,0,0,1-4.92,8.92,42.86,42.86,0,0,1-3.28,4.59,26.66,26.66,0,0,1-4.95,4.74,17.24,17.24,0,0,1-4,2.15,14.49,14.49,0,0,1-5.6.88,14.05,14.05,0,0,1-5.54-1.4l-.57-.29c-.18-.09-.4-.21-.49-.27l-.73-.44c-.5-.29-.93-.59-1.35-.89a52.48,52.48,0,0,1-8.08-7.33c-2.25-2.48-4.32-4.95-6.28-7.46s-3.83-5-5.66-7.57l-2.72-3.83L262,183c-.47-.67-.89-1.27-1.39-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,137.78l-1.52-1S253,138.37,254,137.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.34 124.46 290.18 125.09 233.86 110.96 234.02 110.33 263.65 111.53 290.34 124.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.18 125.09 260.55 123.89 233.86 110.96 263.49 112.17 290.18 125.09",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,131.8a154.4,154.4,0,0,0-32.8-8.23c-.7-.09-1.22-.64-1.09-1.16l2-8a1,1,0,0,1,1.19-.61,154.39,154.39,0,0,1,33.45,8.39,1,1,0,0,1,.75,1.1l-2,8A1.1,1.1,0,0,1,276,131.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,131.8a154.4,154.4,0,0,0-32.8-8.23c-.7-.09-1.22-.64-1.09-1.16l2-8a1,1,0,0,1,1.19-.61,154.39,154.39,0,0,1,33.45,8.39,1,1,0,0,1,.75,1.1l-2,8A1.1,1.1,0,0,1,276,131.8Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,154.83a.54.54,0,0,1-.34-.12.54.54,0,0,1-.06-.75c4.9-5.77,2.18-8.38-1.59-12-2.16-2.08-4.62-4.44-5.86-7.78-3.43-9.21,7.05-15.29,7.15-15.35a.53.53,0,0,1,.72.2.52.52,0,0,1-.19.72c-.41.23-9.8,5.7-6.69,14.06,1.16,3.12,3.52,5.39,5.61,7.39,3.7,3.56,7.2,6.92,1.66,13.44A.53.53,0,0,1,281,154.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,155.79a1.49,1.49,0,1,1,1.48-1.49A1.49,1.49,0,0,1,281,155.79Zm0-1.91a.43.43,0,1,0,.42.42A.42.42,0,0,0,281,153.88Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.f001048ffba8fce440f4372af8319e85.svg";
export { ForwardRef as ReactComponent };